import { Grid, makeStyles, Typography } from "@material-ui/core";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { LoadingDialog } from "../../../../components/LoadingDialog";
import { LibraryItem } from "../../../../entities/LibraryItem";
import { LibraryItemType } from "../../../../entities/LibraryItemType";
import { LinkAssetType } from "../../../../entities/LinkAssetType";
import { routes } from "../../../../routes";
import { FileAssetService } from "../../../../services/FIleAssetService";
import { LibraryItemIcon } from "../../Views/Components/LibraryItemIcon";
import { ShowEmbeddedLinkDialog } from "../../Views/Components/ShowEmbeddedLinkDialog";

const useStyles = makeStyles((theme) => ({
    title: {
        whiteSpace: "normal",
        overflow: "hidden",
        textOverflow: "ellipsis",
        "&:hover": {
            textDecoration: "underline",
            color: "#1967d2",
            cursor: "pointer",
        },
    }
}));

interface Props {
    item: LibraryItem;
}


export function DrawerHeader(props:Props){
    const { item } = props;
    const history = useHistory();
    const classes = useStyles();
    const [showEmbeddedLinkDialog, setShowEmbeddedLinkDialog] = useState(false);
    const [downloading, setDownloading] = useState(false)

    const handleTitleClick = async() => {
        switch (item.type) {
			case LibraryItemType.BuilderAsset:
				return history.push(routes.app.resolve.builderPage(item.id), { prevUrl: window.location.href });

			case LibraryItemType.LinkAsset: {
				if (item.linkType! === LinkAssetType.General && item.linkUrl != null) {
					const redirectUrl = item.linkUrl.match(/^https?:\/\//i) ? item.linkUrl : "//" + item.linkUrl;
					return window.open(redirectUrl, "_blank");
				} else {
					return setShowEmbeddedLinkDialog(true)
				}
			}

			case LibraryItemType.FileAsset: {
                setDownloading(true);                
                await FileAssetService.downloadFile(item.id, item.name)
                setDownloading(false);   
                return;             
            }

			default:
                return history.push(routes.app.resolve.libraryFolder(item.id))
		}
    }

    return (
        <>
            <Grid container alignItems="center" justifyContent="space-evenly" style={{paddingTop: 10, minHeight: 64,}}>
                <Grid item xs={1}>
                    <LibraryItemIcon itemType={item.type} isTemplate={item.isTemplate} linkType={item.linkType} />
                </Grid>
                <Grid item xs={10}>
                    <Typography
                        variant="h5"
                        className={classes.title}
                        onClick={() => handleTitleClick()}
                        >
                        {item.name}
                    </Typography>
                </Grid>
            </Grid>
            { item.type === LibraryItemType.LinkAsset &&
                <ShowEmbeddedLinkDialog 
                    open={showEmbeddedLinkDialog} 
                    onClose={() => setShowEmbeddedLinkDialog(false)} 
                    linkUrl={item.linkUrl!}
                    linkType={item.linkType!} 
                />
            }
            { downloading && <LoadingDialog text='Downloading' />}
        </>
    )
}